import { render } from "./ThankYouView.vue?vue&type=template&id=6bf037dc&scoped=true"
import script from "./ThankYouView.vue?vue&type=script&lang=js"
export * from "./ThankYouView.vue?vue&type=script&lang=js"

import "./ThankYouView.vue?vue&type=style&index=0&id=6bf037dc&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf037dc"]])

export default __exports__